<script lang="ts">
import { defineComponent, PropType } from 'vue';
import type { Group } from '@/types/Groups';
import TreeNode from '@/components/TreeNode.vue'; 

export default defineComponent({
	name: 'TreeView',
	components: {
		TreeNode, // Ensure TreeNode is registered here
	},
	props: {
		groupTree: {
			type: Array as PropType<Group[]>,
			required: true,
		},
		parentGroup: {
			type: Number,
			required: false,
		},
		selectedGroup: {
			type: Number,
			required: false,
		},
	},
	setup(props, { emit }) {
		const handleSelectGroup = (id: number) => {
			emit('select-group', id);
		};

		const handleDropItem = (id: number, event: DragEvent) => {
			emit('drop-item', id, event);
		};
		const calculateTotalGroupCount = (groups: Group[]): number => {
			let totalCount = 0;

			const countGroups = (groupList: Group[]): void => {
				for (const group of groupList) {
					totalCount += 1; // Count the current group
					if (group.children && group.children.length > 0) {
						countGroups(group.children); // Recursively count children
					}
				}
			};

			countGroups(groups);
			return totalCount;
		};

		// Calculate the total count based on groupTree prop
		const defaultToOpen = calculateTotalGroupCount(props.groupTree) > 40 ? false :true;

		return { defaultToOpen,handleSelectGroup, handleDropItem };
	},
});
</script>

<template>
  <div>
    <!-- Assuming you're looping through groupTree -->
    <TreeNode v-for="group in groupTree" :key="group.id" :group="group" :selectedGroup="selectedGroup" @select-group="handleSelectGroup" @drop-item="handleDropItem" :open="defaultToOpen"/>
  </div>
</template>

